import AlertsContext from 'contexts/AlertsContext';
import { useContext } from 'react';

const useAlerts = () => useContext(AlertsContext);

export default useAlerts;